import { render } from "./Stap1.vue?vue&type=template&id=ae994ed4"
import script from "./Stap1.vue?vue&type=script&lang=js"
export * from "./Stap1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__